import { Context, type Effect, Layer, type Scope } from "effect";
import type { ChunkRecoveryIoFailure, ChunkRecoveryNotice, ChunkRecoveryResult } from "./model.ts";

export class ChunkRecoveryIo extends Context.Service<ChunkRecoveryIo, {
  readonly listen: (notify: (notice: ChunkRecoveryNotice) => void) => Effect.Effect<void, ChunkRecoveryIoFailure, Scope.Scope>;
  readonly readGuard: Effect.Effect<unknown, ChunkRecoveryIoFailure>;
  readonly now: Effect.Effect<unknown, ChunkRecoveryIoFailure>;
  readonly writeGuard: (now: number) => Effect.Effect<void, ChunkRecoveryIoFailure>;
  readonly reload: Effect.Effect<void, ChunkRecoveryIoFailure>;
}>()("workerstation/frontend/ChunkRecoveryIo") {}
export const ChunkRecoveryIoTest = (io: typeof ChunkRecoveryIo.Service) => Layer.succeed(ChunkRecoveryIo, io);
export class ChunkRecovery extends Context.Service<ChunkRecovery, {
  readonly request: Effect.Effect<ChunkRecoveryResult, ChunkRecoveryIoFailure>;
}>()("workerstation/frontend/ChunkRecovery") {}
